<template>
  <b-container class="my-4">
    <b-card class="mt-4" v-if="entry.collection !== 'singles' && !entry.template" header="Block">
      <!-- <template v-slot:header>
        <span class="p-2 d-inline-block">Block</span><b-button size="sm" variant="primary float-right" @click="entry_create(site.collections[entry.collection])">Add another</b-button>
      </template> -->

      <div v-if="entry.collection === 'services'">
        <b-form-group label="Icon" label-cols="4">
          <div v-if="entry.block.content.icon">
            <img height="48" :src="entry.block.content.icon" class="mr-2"/>
            <b-button  variant="danger" @click="delete_icon()">Remove icon</b-button>
          </div>
          <ImageSearch v-else :type="['upload', 'fa_icon']" classProp="btn btn-secondary" :action="url => {this.entry.block.content.icon = url; save()}" :is_small="true"/>
        </b-form-group>

        <b-form-group label="Description" label-cols="4">
          <b-form-textarea v-model="entry.block.content.description" @change="save"></b-form-textarea>
        </b-form-group>

        <!-- <b-form-group label="Folder" label-cols="4">
          <b-form-select v-model="entry.block.content.folder" :options="site.collections.services.folders" @change="save"></b-form-select>
        </b-form-group> -->
      </div>

      <div v-if="entry.collection === 'blogs'">
        <b-form-group label="Title" label-cols="4">
          <b-form-input v-model="entry.block.content.title" @change="save"></b-form-input>
        </b-form-group>

        <b-form-group label="Description" label-cols="4">
          <b-form-textarea v-model="entry.block.content.description" @change="save"></b-form-textarea>
        </b-form-group>
      </div>

      <div v-if="entry.collection === 'awards'">
        <b-form-group label="Logo" label-cols="4">
          <b-button v-if="entry.block.content.image" variant="danger" @click="entry.block.content.image = null; this.save()">Remove image</b-button>
          <ImageSearch v-else :type="['upload']" classProp="btn btn-secondary" :action="url => {this.entry.block.content.image = url; this.save()}" :is_small="true" />
        </b-form-group>

        <b-form-group label="link" label-cols="4">
          <b-form-input v-model="entry.block.content.link" @change="save"></b-form-input>
        </b-form-group>
      </div>

      <div v-if="entry.collection === 'testimonials'">
        <b-form-group label="Testimonial" label-cols="4">
          <b-form-textarea v-model="entry.block.content.testimonial" @change="save"></b-form-textarea>
        </b-form-group>

        <b-form-group label="Person" label-cols="4">
          <b-form-input v-model="entry.block.content.person" @change="save"></b-form-input>
        </b-form-group>

        <b-form-group label="Organisation" label-cols="4">
          <b-form-input v-model="entry.block.content.organisation" @change="save"></b-form-input>
        </b-form-group>

        <b-form-group label="Star Rating" label-cols="4">
          <b-form-input v-model="entry.block.content.rating" type="range" min="0" max="5" @change="save"></b-form-input>
          <span>{{entry.block.content.rating}} stars</span>
        </b-form-group>

        <b-form-group label="Person image" label-cols="4">
          <b-button v-if="entry.block.content.person_image" variant="danger" @click="entry.block.content.person_image = null; this.save()">Remove image</b-button>
          <ImageSearch v-else :type="['upload']" classProp="btn btn-secondary" :action="url => {this.entry.block.content.person_image = url; this.save()}" :is_small="true" />
        </b-form-group>
      </div>

      <div v-if="entry.collection === 'forms'">
        <b-form-group label="Header" label-cols="4">
          <b-form-input v-model="entry.block.content.header" @change="save"></b-form-input>
        </b-form-group>

        <b-form-group label="Sub heading" label-cols="4">
          <b-form-textarea v-model="entry.block.content.sub_heading" @change="save"></b-form-textarea>
        </b-form-group>

        <b-form-group label="Fields" label-cols="4">
          <b-form-select v-model="entry.block.content.fields" :options="[{value: 'first_name', text: 'First name'}, {value: 'last_name', text: 'Last name'}, {value: 'email', text: 'Email'}, {value: 'phone', text: 'Phone'}, {value: 'comments', text: 'Comments'}]" multiple @change="save"></b-form-select>
        </b-form-group>
      </div>
    </b-card>

    <b-card header="Page" v-if="!entry.template && entry.types.indexOf('page') > -1" class="mt-4">
      <b-form-group label="Title" label-cols="4">
        <b-form-input v-model="entry.page.title" required @change="save"></b-form-input>
      </b-form-group>

      <b-form-group label="Slug" label-cols="4">
        <b-input-group :prepend="`${entry.collection !== 'singles' ? entry.collection : ''} / ${entry.block && entry.block.content && entry.block.content.folder ? entry.block.content.folder + ' / ' : ''}`" >
          <b-form-input v-model="entry.page.slug" required @change="save"></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-card>

    <b-card header="Entity" class="mt-4">
      <b-form-group label="Name" label-cols="4">
        <b-form-input v-model="entry.name" required @change="save"></b-form-input>
      </b-form-group>

      <b-form-group label="Status" label-cols="4">
        <b-form-select v-model="entry.status" :options="['published', 'draft']" @change="save"></b-form-select>
      </b-form-group>
    </b-card>

    <b-card v-if="!entry.template" class="mt-4" bg-variant="danger" header="Delete entity" text-variant="white">
      <p class="text-white">Delete this entity</p>
      <!-- TODO what if it is used in a page already? -->
      <LoadingButton @click="delete_entry">Delete</LoadingButton>
    </b-card>
  </b-container>
</template>

<script>
import {db, serverTimestamp, FieldValue} from '@/main.js'
import ImageSearch from '@/components/ImageSearch'
import EntryMixin from '@/mixins/Entry.js'

export default {
  name: 'entry_page_settings',
  props: ['site', 'entry'],
  components: {ImageSearch},
  mixins: [EntryMixin],
  data() {
    return {
      is_saving: false
    }
  },
  methods: {
    delete_icon() {
      this.entry.block.content.icon = null
      this.save()
    },
    async save() {
      this.is_saving = true

      let update = {
        name: this.entry.name,
        status: this.entry.status,
      }

      if (this.entry.block && this.entry.block.content) {
        update['block.content'] = this.entry.block.content
      }

      if (this.entry.page && this.entry.page.slug) {
        update['page.slug'] = this.entry.page.slug
      }

      if (this.entry.page && this.entry.page.title) {
        update['page.title'] = this.entry.page.title
      }

      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).update(update)
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})

      this.$bvToast.toast(`Changes have been saved`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})

      this.is_saving = false
    },
    async delete_entry() {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      // TODO needs to be removed from all blocks which use this field
      let entry_collection = this.entry.collection

      let update = {}
      update[`collections.${entry_collection}.entries`] = FieldValue.arrayRemove(db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id))
      await db.collection('site').doc(this.$route.params.site_id).update(update)
      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).delete()
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})

      this.$router.push({name: entry_collection})
    }
  }
}
</script>

<style>

</style>
